module.exports = __webpack_public_path__ + "static/img/vision_pic@2x.7dbfba5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/new_home/vision_pic@2x.jpg
// module id = 519
// module chunks = 0